import { computed, defineAsyncComponent, markRaw, unref } from 'vue';

// Omnia records keep their 3D models and krpano panoramas in standard record
// fields. This sheet-body adapter renders the shared viewers through the same
// widget contract Hera uses; the shared SheetContent stays unaware of the tenant.
const MEDIA_SHEETS = Object.freeze({ omnia_ra: 'model', omnia_drawing: 'panorama' });
// Lazy: the registry imports this adapter, and the viewer imports shared components.
const OmniaMediaViewer = markRaw(defineAsyncComponent(() => import('../Components/Sheets/OmniaMediaViewer.vue')));

const safeUrl = value => {
    if (typeof value !== 'string' || value === '') return null;
    try {
        return ['http:', 'https:'].includes(new URL(value, 'https://catalog.invalid').protocol) ? value : null;
    } catch {
        return null;
    }
};

/** Viewer sources of a record, or null when the sheet has no Omnia media. */
export function omniaMediaSources(sheetName, record, publicAudience = false) {
    const kind = MEDIA_SHEETS[sheetName];
    if (!kind || record?.id === null || record?.id === undefined) return null;
    if (kind === 'model') {
        const modelUrl = safeUrl(record.model3dUrl);
        return modelUrl ? { modelUrl } : null;
    }
    if (!record.pano && !record.panoId) return null;
    // Manifests and tiles are proxied per record by the authorized panorama routes.
    return { panoramaUrl: `${publicAudience ? '/public' : ''}/omnia/panorama/${encodeURIComponent(String(record.id))}/manifest.xml` };
}

export function createOmniaMediaWidget({ sheet, record, publicAudience }) {
    const sources = computed(() => omniaMediaSources(unref(sheet)?.name, unref(record), Boolean(unref(publicAudience))));

    return {
        slot: 'scheda:before-content-actions',
        actionBlocks: computed(() => sources.value ? [{
            id: 'omnia-media-viewer',
            component: OmniaMediaViewer,
            props: sources.value,
        }] : []),
    };
}

export const sheetContentWidgetFactories = [createOmniaMediaWidget];
